import { ConfirmCancelDialog, Spacer, Text, useToast } from '@color/continuum';
import { useState } from 'react';

import { useImportRawDataMutation } from '../api';
import { FileDropzone } from '../FileDropzone';

const ACCEPTED_EXTENSIONS = '.zip';

interface ImportRawDataDialogProps {
  onClose: () => void;
  onSuccess: () => void;
}

export const ImportRawDataDialog = ({ onClose, onSuccess }: ImportRawDataDialogProps) => {
  const [file, setFile] = useState<File | null>(null);
  const { showToast } = useToast();
  const { mutateAsync: importRawData, isPending } = useImportRawDataMutation();

  const handleSubmit = async () => {
    if (!file) return;
    try {
      await importRawData(file);
      showToast('Raw Sanger data imported.', { severity: 'success' });
      onSuccess();
    } catch {
      // Error toast shown by the mutation hook.
    }
  };

  return (
    <ConfirmCancelDialog
      title="Import Raw Sanger Data"
      confirmButtonText="Import"
      confirmButtonProps={{ disabled: !file || isPending }}
      onAccept={handleSubmit}
      onCancel={onClose}
      dialogIsOpen
      maxWidth="sm"
      fullWidth
    >
      <Text>Please select a zip file of raw Sanger data (.ab1) files.</Text>
      <Spacer variant="medium" />
      <FileDropzone
        files={file ? [file] : []}
        onFilesChange={(files) => setFile(files[0] ?? null)}
        acceptedExtensions={ACCEPTED_EXTENSIONS}
      />
    </ConfirmCancelDialog>
  );
};
